import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { timelineItems } from '@/mocks/home';

export default function UpdateTimeline() {
  return (
    <section id="timeline" className="scroll-mt-24 bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="04"
            eyebrow="DAILY RHYTHM"
            title="一天里的更新节奏"
            description="四个渠道各有各的发布时间。记住这几个时间点，你就知道什么时段该去哪里看黑料官方的更新。"
          />
        </Reveal>

        <div className="mt-12 md:mt-16">
          <ol className="relative border-l border-background-300 pl-8 md:pl-12">
            {timelineItems.map((item, index) => (
              <li key={item.time} className="relative pb-10 last:pb-0 md:pb-14">
                <Reveal delay={index * 70}>
                  <span className="absolute -left-[41px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-100 bg-primary-500 md:-left-[57px]"></span>
                  <div className="flex flex-col gap-2 md:flex-row md:items-baseline md:gap-8">
                    <span className="w-16 shrink-0 font-heading text-lg font-bold text-primary-600 md:text-xl">
                      {item.time}
                    </span>
                    <div className="max-w-2xl">
                      <div className="flex flex-wrap items-center gap-3">
                        <h3 className="font-heading text-lg font-semibold text-foreground-950">
                          {item.title}
                        </h3>
                        <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                          {item.platform}
                        </span>
                      </div>
                      <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </Reveal>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}